import $ from "jquery";
import cookies from "vue-cookies";
import vueWaterfallEasy from 'vue-waterfall-easy'
export default {
    name: "Home",
    components: {
        vueWaterfallEasy,
    },
    data() {
        return {
            flag: true,
            activeName: 'itemFlag',
            currentPage: 1,
            pageSize: 10,
            totalSize: 50,
            imgsArr: [],
            orderId: "",
            searchContent: "",
            curretSubjectId: "",
            currentSubjectParam: { itemFlag: 'item' },
            subjectListData: [],
            contentListData: [],
            searchFileForm: {},
            props: {
                label: "name",
                children: "children",
                isLeaf: "leaf",
            },
        };
    },
    mounted() {
        // 统一验证token
        var currentToken = cookies.get("token");
        $.ajaxSetup({
            headers: {
                AuthorizationToken: currentToken,
            },
            complete: function (xhr) {
                if (xhr.responseJSON.code == 401) {
                    window.location.href = "/";
                }
            },
        });

    },
    methods: {
        onSearch() {
            console.log(this.searchContent);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: "/zyk/webapi/search",
                data: {
                    content: this.searchContent
                },
                success: function (data) {
                    if (data.code == 200) {
                        console.log(data.obj.wordList);
                    } else {
                        alert(data.msg);
                    }
                },
                error: function () {
                    console.log("失败了");
                },
            });
        },
        handleClick() {
            // console.log(tab, event);
            var that = this;
            that.imgsArr = []
            switch (this.activeName) {
                case 'itemFlag':
                    that.currentSubjectParam = { itemFlag: "item" };
                    break
                case 'imgFlag':
                    that.currentSubjectParam = { imgFlag: "img" };
                    break
                case 'audioFlag':
                    that.currentSubjectParam = { audioFlag: "audio" };
                    break
                case 'videoFlag':
                    that.currentSubjectParam = { videoFlag: "video" };
                    break
            }
        },
        // 加载数据
        searchParam() {
            let that = this;
            let params = Object.assign({}, this.searchFileForm);
            params.subjectId = this.curretSubjectId;
            // params.orderId = this.orderId
            params.size = 20
            var url = ""
            if (this.activeName == "itemFlag") {
                url = "/zyk/webapi/wordList"
            } else {
                url = "/zyk/webapi/resourceList"
            }
            $.ajax({
                url: url,
                type: "GET",
                data: params,
                dataType: "json",
                success: function (data) {
                    $.each(data.obj.list, function (index, item) {
                        switch (that.activeName) {
                            case 'itemFlag':
                                that.contentListData.push(item);
                                that.orderId = that.contentListData[that.contentListData.length - 1].orderId
                                break;
                            case 'imgFlag':
                                that.imgsArr.push({
                                    src: item.httpPath,
                                    href: "/mediaPreview?id=" + item.id,
                                    title: item.title
                                })
                                break;
                            case 'audioFlag':
                                that.contentListData.push(item);
                                break;
                            // default:
                            //     break;
                        }
                    })
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.reload();
                    }
                },
            });
        },
        toChangeData(current) {
            var navList = $('.contentTabs');
            var that = this
            for (var i = 0; i < navList.length; i++) {
                $(navList[i]).removeClass('cuttentNav')
            }
            $(this.$refs[current]).addClass('cuttentNav')
            switch (current) {
                case 'itemFlag':
                    that.currentSubjectParam = { itemFlag: "item" };
                    break
                case 'imgFlag':
                    that.currentSubjectParam = { imgFlag: "img" };
                    break
                case 'audioFlag':
                    that.currentSubjectParam = { audioFlag: "audio" };
                    break
                case 'videoFlag':
                    that.currentSubjectParam = { videoFlag: "video" };
                    break
            }
        },
        // 获取getWaterfallData数据
        getWaterfallData() {

        },
        // 树形结构加载
        loadNode(node, resolve) {
            var currentToken = cookies.get("token");
            $.ajax({
                url: "/zyk/webapi/subjectTree",
                type: "GET",
                data: this.currentSubjectParam,
                headers: {
                    AuthorizationToken: currentToken,
                },
                //contentType: 'application/json;charset=utf-8',
                dataType: "json",
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.reload();
                    }
                },
                success: function (data) {
                    if (node.level == 0) {
                        this.treeNode_had = node;
                        return resolve(data.obj);
                    } else {
                        $.ajax({
                            // url: "/zyk/webapi/subjectTree",
                            url: "/zyk/webapi/subjectTree",
                            type: "GET",
                            //contentType: 'application/json;charset=utf-8',
                            data: { id: node.data.id },
                            dataType: "json",
                            error: function (xhr) {
                                if (xhr.status == 401) {
                                    window.location.reload();
                                }
                            },
                            success: function (data) {
                                return resolve(data.obj);
                            },
                        });
                    }
                },
            });
        },
        // 树形结构加载
        // getSubjectListData(param) {
        //     let that = this;
        //     $.ajax({
        //         url: "/zyk/webapi/subjectTree",
        //         type: "GET",
        //         data: param,
        //         dataType: "json",
        //         success: function (data) {
        //             that.subjectListData = data.obj
        //         },
        //         error: function (xhr) {
        //             if (xhr.status == 401) {
        //                 window.location.reload();
        //             }
        //         },
        //     });
        // },
        // getContentListData(currentId) {
        //     $.ajax({
        //         url: "/zyk/webapi/wordList",
        //         type: "GET",
        //         data: { subjectId: currentId },
        //         dataType: "json",
        //         success: function (data) {
        //             console.log(data.obj.list);
        //         },
        //         error: function (xhr) {
        //             if (xhr.status == 401) {
        //                 window.location.reload();
        //             }
        //         },
        //     });
        // }
        // 点击树
        listClick(node) {
            var that = this;
            that.curretSubjectId = node.id
            that.contentListData = []
            this.searchParam();

        },
        // 跳转下一页
        getNextPageData() {
            this.searchParam()
        },
        // 跳转详情
        toPreview(wordId) {
            var that = this
            var downloadA = document.createElement("a");
            if (that.activeName == "audioFlag") {
                downloadA.href = "/mediaPreview?id=" + wordId;
            } else {
                downloadA.href = "/preview?id=" + wordId;
            }
            downloadA.target = "_blank";
            downloadA.click();
        },
    }
};